let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("huUvS")).then(() => parcelRequire('4dLYc'));